import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {T2ThemeService} from '../../../../trip2-theme/t2-theme.service';
import {ComplianceService} from '../../../../core/services/compliance.service';
import {GridOptions} from 'ag-grid';
import {IUserInterface} from '../../../../core/interfaces/user.interface';
import {IUserproviderInterface} from '../../../../core/interfaces/userprovider.interface';
import {IComplianceInterface, IDocumentInterface} from '../../../../core/interfaces/compliance.interface';
import {T2LoadingService} from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import * as moment from 'moment';
import {ComunicationDashboard} from '../../../dashboard-providers/comunication-dashboard';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-compliance-documents',
  templateUrl: './compliance-documents.component.html',
  styleUrls: ['./compliance-documents.component.scss']
})
export class ComplianceDocumentsComponent implements OnInit, OnDestroy {

  public gridCompliance: GridOptions;
  public rowData: IComplianceInterface[];
  public subscribe: Subscription[];
  public userProviders: IUserproviderInterface[];
  public driverExpired: number;
  @Output() closeCard = new EventEmitter<boolean>();
  constructor(
    private serviceCompliance: ComplianceService,
    private _comunicationDashboard: ComunicationDashboard
  ) {
    this.driverExpired = 0;
    this.subscribe = [];
    this.createGrid();
  }

  ngOnInit() {
    this.comunication();
  }

  ngOnDestroy(): void {
    this.subscribe.forEach(
      (sub: Subscription) => {
        sub.unsubscribe();
      }
    );
  }

  comunication() {
    const received: Subscription = this._comunicationDashboard.receivedId.subscribe(
      (id: number) => {
        this.getCompliances(id);
      }
    );
    this.subscribe.push(received);
  }
  /**@name createGrid
   * @description Crea la grilla
   */
  createGrid(): void {
    this.gridCompliance = <GridOptions>{};
    this.gridCompliance.columnDefs = this.createColums();
    // this.gridCompliance.api.sizeColumnsToFit();
  }

  /**@name createColums
   * @description Retorna las columnas para la grilla
   */
  createColums() {
    const elIs = this;
    return [
      {
        headerName: 'Driver #',
        field: 'driverid',
        colId: 'driverid',
        width: 60,
      },
      {
        headerName: 'Name',
        field: 'driverfullname',
        colId: 'driverfullname',
        width: 100,
      },
      {
        headerName: 'Document Expired',
        field: 'description',
        colId: 'document',
        width: 60,
        cellStyle: {textAlign: 'center'},
        /*cellRenderer: function (param) {
          return elIs.verifyExpiration(param.data, true);
        }*/
      },
      {
        headerName: 'Date Expired',
        field: 'expirationdate',
        colId: 'expirationdate',
        width: 60,
        cellStyle: {textAlign: 'center'},
        /*cellRenderer: function (param) {
          return elIs.verifyExpiration(param.data, false);
        }*/
      }
    ];
  }

  verifyExpiration(data: IComplianceInterface, expired: boolean) {
    let exp = 0;
    data.documents.forEach(
      (doc: IDocumentInterface) => {
        if (moment(doc.expirationdate).isAfter(moment()) && !expired) {exp++; }
        if (moment(doc.expirationdate).isBefore(moment()) && expired) {exp++; }
      }
    );
      return `${exp}`;
  }

  /**@name getCompliances
   * @description Trae los drivers con documentos vencidos
   * @param id = payorid
   */
  getCompliances(id: number) {
    const compliance: Subscription = this.serviceCompliance.getCompliance(id).subscribe(
      (compliances: IComplianceInterface[]) => {
        this.modifyAndLoadCompliance(compliances);
      },
      error => {
      }
    );
    this.subscribe.push(compliance);
  }

  /**@name modifyAndLoadCompliance
   * @description Modifica y carga los datos
   * @param compliances = IComplianceInterface[]
   */
  modifyAndLoadCompliance(compliances: IComplianceInterface[]) {
    const data: IDocumentInterface[] = [];
    compliances.forEach(
      (compliance: IComplianceInterface) => {
        compliance.documents.forEach(
          (doc: IDocumentInterface) => {
            doc.driverfullname = compliance.driverfullname;
            doc.driverid = compliance.driverid;
            data.push(doc);
          }
        );
      }
    );
    this.gridCompliance.api.setRowData(data);
    this.driverExpired = data.length;
    this.gridCompliance.api.sizeColumnsToFit();
  }

  /**@name onGetComplianceByProvider
   * @description call getCompliances
   * @param id = payorid
   */
  onGetComplianceByProvider(id: number) {
    this.getCompliances(id);
  }

  /**@name onExport
   * @description Exporta en exel los datos de la grilla
   */
  onExport() {
    const data = { allColumns: true, fileName: 'Compliance Document.xls'};
    this.gridCompliance.api.exportDataAsExcel(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/documents-verify/components/compliance-documents/compliance-documents.component.ts